// blakfy-cookie/src/i18n/translations/id.js — Indonesian translations

export default {
  title: "Preferensi Cookie",
  intro:
    "Situs ini menggunakan cookie untuk meningkatkan pengalaman Anda. Lihat Kebijakan Cookie kami.",
  policyLink: "Kebijakan Cookie",
  acceptAll: "Terima Semua",
  rejectAll: "Tolak Semua",
  preferences: "Preferensi",
  save: "Simpan Pilihan",
  close: "Tutup",
  cat: {
    essential: {
      title: "Cookie Esensial",
      desc: "Diperlukan untuk fungsi dasar situs. Tidak dapat dinonaktifkan.",
      always: "Selalu aktif",
    },
    analytics: {
      title: "Cookie Analitik",
      desc: "Digunakan untuk mengumpulkan statistik kunjungan anonim.",
    },
    marketing: {
      title: "Cookie Pemasaran",
      desc: "Digunakan untuk iklan yang dipersonalisasi dan retargeting.",
    },
    functional: {
      title: "Cookie Fungsional",
      desc: "Digunakan untuk mengingat preferensi seperti bahasa dan tema.",
    },
  },
  placeholder: {
    title: "Konten diblokir",
    desc: "Anda harus mengizinkan cookie {category} untuk melihat konten ini.",
    cta: "Izinkan",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
